// src/Pages/GodownMaster.jsx
import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Box, Paper, Grid, TextField, Button, Typography, Stack } from '@mui/material';

// const path = `http://192.168.1.248:3103/api`

function GodownMaster({ mode, loggedInUser, companyData, connectionString }) {
    const { id } = useParams();
    const navigate = useNavigate();
    const [GodownName, setGodownName] = useState('');
    const path = `${connectionString}/api`;

    const companyId = companyData?.companyId;
    const fYear = companyData?.selectedFinancialYear;
    const userId = loggedInUser?.userId;

    useEffect(() => {
        if (mode === 'edit') {
            axios.get(`${path}/godown/getDetails/${id}`)
                .then((response) => setGodownName(response.data.GodownName))
                .catch((error) => console.error('Error fetching godown data:', error));
        }
    }, [id, mode]);

    const funReset = () => {
        setGodownName('');
    };

    const funSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = { GodownName, companyId, fYear, userId };

            if (mode === 'add') {
                await axios.post(`${path}/godown/insert`, payload);
                setGodownName('');
                alert('Data inserted successfully');
            } else if (mode === 'edit') {
                await axios.put(`${path}/godown/update/${id}`, payload);
                alert('Data updated successfully');
            }
            navigate('/main/godownDetail');
        } catch (error) {
            console.error('Error inserting/updating data:', error);
            alert(`Error ${mode === 'add' ? 'inserting' : 'updating'} data`);
        }
    };

    return (
        <Box display="flex" justifyContent="center" alignItems="center" mt={4}>
            <Paper
                elevation={3}
                sx={{
                    px: 4,
                    py: 5,
                    borderRadius: 3,
                    maxWidth: 480,
                    width: '100%',
                    bgcolor: '#F8FAFC',
                    border: '1px solid #e5e7eb',
                    boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.05)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 3,
                }}
            >
                <Typography
                    variant="h6"
                    fontWeight={600}
                    color="primary.main"
                    sx={{ textAlign: 'center', fontSize: '1.25rem' }}
                >
                    {mode === 'add' ? 'Add Godown' : 'Edit Godown'}
                </Typography>

                <Box component="form" onSubmit={funSubmit} display="flex" flexDirection="column" gap={3}>
                    <TextField
                        fullWidth
                        required
                        label="Godown Name"
                        value={GodownName}
                        onChange={(e) => setGodownName(e.target.value)}
                        variant="outlined"
                        size="small"
                    />

                    <Stack direction="row" spacing={2} justifyContent="center">
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            sx={{ textTransform: 'none', px: 4 }}
                        >
                            {mode === 'add' ? 'Save' : 'Update'}
                        </Button>

                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={funReset}
                            sx={{ textTransform: 'none', px: 4 }}
                        >
                            Reset
                        </Button>

                        <Button
                            component={Link}
                            to="/main/godownDetail"
                            variant="outlined"
                            color="error"
                            sx={{ textTransform: 'none', px: 4 }}
                        >
                            Cancel
                        </Button>
                    </Stack>
                </Box>
            </Paper>
        </Box>
    );
}

export default GodownMaster;